import { Component, OnInit } from '@angular/core';
import { MobileNavService } from '../../shared/services/mobile-nav.service';

@Component({
  selector: 'app-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss']
})
export class MobileHeaderComponent implements OnInit {

    constructor( public mobileNav: MobileNavService) { }

    ngOnInit() {
    }

    // onClickMe() {
    //     this.mobileNav.showSideNav();
    // }

}
